import { c as _c } from "react/compiler-runtime";
import { useAtom } from 'jotai';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';
import { Button } from 'react-aria-components';
import { BsFillGridFill } from 'react-icons/bs';
import { FaList } from 'react-icons/fa6';
import { useIsMounted } from 'usehooks-ts';
import { listingsViewAtom } from '@/features/listing/atoms/listings-view-atom';
import ListingFilterNew from '@/features/listing/components/listings-filters/listing-filter-new/listing-filter-new';
import { LISTING_VIEW_VARIANTS } from '@/features/listing/constants/listing-constants';
import { getCookieListingView, setCookieListingView } from '@/features/listing/cookies/cookie-listing-view';
import { type ListingsFilterName } from '@/features/listing/types/listing-filters-types';
import styles from './listing-view-select.module.scss';
interface ListingViewSelectProps {
  onFilterDisplayChange: (filterName: ListingsFilterName | null) => void;
}
export default function ListingViewSelect(props) {
  const $ = _c(46);
  const {
    onFilterDisplayChange
  } = props;
  const isMounted = useIsMounted();
  const filtersViewTranslate = useTranslations("listing.filters.view");
  const [listingsView, setListingView] = useAtom(listingsViewAtom);
  const [isPopoverOpen, setPopoverOpen] = useState(false);
  let t0;
  if ($[0] !== onFilterDisplayChange || $[1] !== setListingView) {
    t0 = value => () => {
      const valueToSet = value === LISTING_VIEW_VARIANTS.list ? LISTING_VIEW_VARIANTS.list : LISTING_VIEW_VARIANTS.grid;
      setListingView(valueToSet);
      setCookieListingView(valueToSet);
      onFilterDisplayChange(null);
      setPopoverOpen(false);
    };
    $[0] = onFilterDisplayChange;
    $[1] = setListingView;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleViewChange = t0;
  let t1;
  if ($[3] !== filtersViewTranslate || $[4] !== listingsView) {
    t1 = () => <>{listingsView === LISTING_VIEW_VARIANTS.list ? <FaList className={styles.listingViewSelect_dropdownIcon} /> : <BsFillGridFill className={styles.listingViewSelect_dropdownIcon} />}{filtersViewTranslate(`options.${listingsView}`)}</>;
    $[3] = filtersViewTranslate;
    $[4] = listingsView;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const renderButtonText = t1;
  let t2;
  if ($[6] !== setListingView) {
    t2 = () => {
      const cookieListingView = getCookieListingView();
      if (cookieListingView) {
        setListingView(cookieListingView);
      }
    };
    $[6] = setListingView;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== isMounted || $[9] !== setListingView) {
    t3 = [isMounted, setListingView];
    $[8] = isMounted;
    $[9] = setListingView;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  useEffect(t2, t3);
  let t4;
  if ($[11] !== renderButtonText) {
    t4 = renderButtonText();
    $[11] = renderButtonText;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== filtersViewTranslate) {
    t5 = filtersViewTranslate("dropdown-title");
    $[13] = filtersViewTranslate;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const t6 = listingsView === LISTING_VIEW_VARIANTS.list;
  let t7;
  if ($[15] !== handleViewChange) {
    t7 = handleViewChange(LISTING_VIEW_VARIANTS.list);
    $[15] = handleViewChange;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FaList className={styles.listingViewSelect_optionIcon} />;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== filtersViewTranslate) {
    t9 = filtersViewTranslate("options.list");
    $[18] = filtersViewTranslate;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t9) {
    t10 = <span>{t9}</span>;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t6 || $[24] !== t7) {
    t11 = <Button className={styles.listingViewSelect_optionItem} value={LISTING_VIEW_VARIANTS.list} isDisabled={t6} onPress={t7}>{t8}{t10}</Button>;
    $[22] = t10;
    $[23] = t6;
    $[24] = t7;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const t12 = listingsView === LISTING_VIEW_VARIANTS.grid;
  let t13;
  if ($[26] !== handleViewChange) {
    t13 = handleViewChange(LISTING_VIEW_VARIANTS.grid);
    $[26] = handleViewChange;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <BsFillGridFill className={styles.listingViewSelect_optionIcon} />;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== filtersViewTranslate) {
    t15 = filtersViewTranslate("options.grid");
    $[29] = filtersViewTranslate;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t15) {
    t16 = <div className={styles.listingViewSelect_optionItem}>{t14}<span>{t15}</span></div>;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t12 || $[34] !== t13 || $[35] !== t16) {
    t17 = <Button className={styles.listingViewSelect_optionItem} isDisabled={t12} value={LISTING_VIEW_VARIANTS.grid} onPress={t13}>{t16}</Button>;
    $[33] = t12;
    $[34] = t13;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t11 || $[38] !== t17) {
    t18 = <div className={styles.listingViewSelect_options}>{t11}{t17}</div>;
    $[37] = t11;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== isPopoverOpen || $[41] !== onFilterDisplayChange || $[42] !== t18 || $[43] !== t4 || $[44] !== t5) {
    t19 = <ListingFilterNew buttonText={t4} dialogTitle={t5} onFilterDisplayChange={onFilterDisplayChange} listingFilterName="listingsView" isPopoverOpen={isPopoverOpen} setPopoverOpen={setPopoverOpen}>{t18}</ListingFilterNew>;
    $[40] = isPopoverOpen;
    $[41] = onFilterDisplayChange;
    $[42] = t18;
    $[43] = t4;
    $[44] = t5;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  return t19;
}